import * as React from 'react';
import { fetchStreamIdIfNeeded, getStreamStatus } from '@/redux/modules/video';
import { isUiMobile } from '@/redux/modules/browser';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import AuctionVideo from '@liveauctioneers/caterwaul-components/lib/AuctionVideo/AuctionVideo';
import styled, { css } from 'styled-components';

type Props = {
    bigVideo: boolean;
    catalogId: number;
    showMobileConsole: boolean;
    toggleBigVideo: () => void;
};

/**
 * Video player for auction livestream
 */
const AuctionVideoStream = ({ bigVideo, catalogId, showMobileConsole, toggleBigVideo }: Props) => {
    const dispatch = useAppDispatch();

    const mobile = useAppSelector(isUiMobile);
    const { status: streamStatus, streamId } = useAppSelector((state) => getStreamStatus(state, catalogId));

    return (
        <StyledAuctionVideo
            $big={bigVideo}
            $showMobileConsole={showMobileConsole}
            bigVideo={bigVideo}
            catalogId={catalogId}
            fetchStreamIdIfNeeded={() => dispatch(fetchStreamIdIfNeeded(catalogId))}
            handleClick={toggleBigVideo}
            mobile={mobile}
            showBigVideoButton
            status={streamStatus}
            streamId={streamId}
        />
    );
};

export default AuctionVideoStream;

const StyledAuctionVideo = styled(AuctionVideo)<{
    $big: boolean;
    $showMobileConsole: boolean;
}>`
    && {
        align-items: center;
        bottom: -5px;
        display: flex;
        height: 120px;
        position: absolute;
        right: -5px;
        transition: all 0.25s ease-in-out;
        width: 213px;
        z-index: 1000;
        ${({ $showMobileConsole }) =>
            $showMobileConsole &&
            css`
                width: 102px;
                height: 58px;
                border: 2px solid ${({ theme }) => theme.colors.black};
                bottom: 0;
                right: 0;
            `}
        ${({ $big }) =>
            $big &&
            css`
                height: 100%;
                width: 100%;
            `}
    }
`;
